import React from 'react';
import Slider from 'react-slick';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        className="text-fivePrimary"
      >
        <circle cx="40" cy="40" r="40" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.2532 40.6336L35.5555 53.332L33.2578 51.0335L43.6579 40.6335L33.2578 30.2335L35.5555 27.9352L48.2532 40.6336Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2699_2509"
            x1="80"
            y1="40"
            x2="0"
            y2="40"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DF1CFF" />
            <stop offset="1" stopColor="#EA0070" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        className="text-fivePrimary rotate-180"
      >
        <circle cx="40" cy="40" r="40" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.2532 40.6336L35.5555 53.332L33.2578 51.0335L43.6579 40.6335L33.2578 30.2335L35.5555 27.9352L48.2532 40.6336Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2699_2509"
            x1="80"
            y1="40"
            x2="0"
            y2="40"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#DF1CFF" />
            <stop offset="1" stopColor="#EA0070" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
function ImagePaging({ images }) {
  const settings = {
    dots: false,
    dotsClass: 'slick-dots slick-thumb',
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: images?.length > 1 && <SampleNextArrow />,
    prevArrow: images?.length > 1 && <SamplePrevArrow />,
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        {images?.map((image, index) => (
          <div key={index} className="five-slider-height">
            <img src={image?.url} alt={`Slide ${index}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ImagePaging;
